$( document ).ready(function() {
	let rellax1_speed = 8;
	let rellax2_speed = 5.5;
	let rellax3_speed = 3;

	if(window.innerWidth < 768){
		rellax1_speed = 4;
		rellax2_speed = 2;
		rellax3_speed = 1.5;
	}

	$('.b2b').each(function (i) {
		var count = i + 1;
		$(this).addClass('b2b-' + count);
		var rellax1 = new Rellax('.b2b-' + count + ' .parallax__layer.speed-1', {
			speed: rellax1_speed,
			center: true,
		});
		var rellax2 = new Rellax('.b2b-' + count + ' .parallax__layer.speed-2', {
			speed: rellax2_speed,
			center: true,
		});
		var rellax3 = new Rellax('.b2b-' + count + ' .parallax__layer.speed-3', {
			speed: rellax3_speed,
			center: true,
		});
	});
});
